module.exports = __webpack_public_path__ + "media/images/fr-portrait@2x-b08d83c3.png";